import { ExternalLicensePoolsScreen } from "./external-license-pools.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { ExternalLicensePoolRoutes } from "../external-license-pool";
import { ExternalLicensePoolEditRoutes } from "../external-license-pool-edit";

export const ExternalLicensePoolsRoutes: RouteDefinition[] = [
	{
		path: Paths.externalLicensePools.path,
		element: <ExternalLicensePoolsScreen />,
		requiredPermissions: ["UserInAccountPermission_ExternalLicenseAdmin_Read"],
	},
	...ExternalLicensePoolRoutes,
	...ExternalLicensePoolEditRoutes,
];
